import type { AlertWindowContentProps } from './AlertWindow.types'
import * as DialogPrimitive from '@radix-ui/react-dialog'
import cn from 'classnames'
import * as React from 'react'
import { Icon } from '../icon'
import { Typography } from '../typography'
import styles from './AlertWindow.module.css'

function Content({
  hasIcon = false,
  text,
  supportingText,
  renderPrimaryActionSlot,
  renderSecondaryActionSlot,
  className,
}: AlertWindowContentProps) {
  const primaryAction = renderPrimaryActionSlot?.({ variant: 'primary' })
  const secondaryAction = renderSecondaryActionSlot?.({ variant: 'transparentNeutral' })

  return (
    <DialogPrimitive.Portal>
      <DialogPrimitive.Overlay className={styles.backdrop} />
      <DialogPrimitive.Content className={cn(styles.alertWindow, className)}>
        {hasIcon && <Icon glyph="ExclamationInTriangle" size={48} className={styles.icon} />}
        <div className={styles.textContainer}>
          <DialogPrimitive.Title asChild>
            <Typography variant="body-m-bold-snug">{text}</Typography>
          </DialogPrimitive.Title>
          {supportingText && (
            <DialogPrimitive.Description asChild>
              <Typography variant="body-s-regular-snug">{supportingText}</Typography>
            </DialogPrimitive.Description>
          )}
        </div>
        {(primaryAction || secondaryAction) && (
          <div className={styles.actionsWrapper}>
            {primaryAction}
            {secondaryAction}
          </div>
        )}
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  )
}

function Root({ children, ...rest }: React.ComponentPropsWithoutRef<typeof DialogPrimitive.Root>) {
  return <DialogPrimitive.Root {...rest}>{children}</DialogPrimitive.Root>
}

function Trigger({ children }: React.PropsWithChildren) {
  return <DialogPrimitive.Trigger asChild>{children}</DialogPrimitive.Trigger>
}

export const AlertWindow = {
  Root,
  Trigger,
  Content,
}
